/**
 * Copyright (c) Asseco Business Solutions S.A. All rights reserved.
 */
import {FOOTER_URL} from "../common/Urls";
import {storageManager} from "../../index";

export async function fetchFooter() {
    return await storageManager.checkClientSessionStorageItem("footer", FOOTER_URL);
}
